import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";

import { toast } from "react-toastify";

import {
  getCDKShipViaDefault,
  getCDKUniqueShipVia,
  postNewCDKShipViaDefault,
  updateCDKShipViaDefault,
} from "../../../services/cdkFieldPreferenceService";

import {
  getCDKCodDefaultValues,
  getCDKUniqueCODValues,
  updateCdkCodDefaultSetting,
  postNewCdkCodDefaultSetting,
} from "../../../services/cdkOrderService";

const QUERY_KEYS = {
  shipViaDefault: ["cdkShipViaDefault"],
  uniqueShipVia: ["cdkUniqueShipVia"],
  codDefaultValues: ["CODDefaultValues"],
  uniqueCODValues: ["uniqueCODValues"],
};

const toastSettingsId = "cdk-settings-toast";

// Ship Via Default

export const useGetCDKShipViaDefault = () =>
  useQuery({
    queryKey: QUERY_KEYS.shipViaDefault,
    queryFn: async () => {
      const response = await getCDKShipViaDefault();

      return response.data;
    },
  });

export const useGetCDKUniqueShipVia = () =>
  useQuery({
    queryKey: QUERY_KEYS.uniqueShipVia,
    queryFn: async () => {
      const response = await getCDKUniqueShipVia("");

      return response.data;
    },
  });

export const usePostNewCDKShipViaDefault = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: postNewCDKShipViaDefault,

    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.shipViaDefault);
      queryClient.invalidateQueries(QUERY_KEYS.uniqueShipVia);

      toast.success("Save Successful", { toastId: toastSettingsId });
    },
  });
};

export const useUpdateCDKShipViaDefault = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateCDKShipViaDefault,

    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.shipViaDefault);
      queryClient.invalidateQueries(QUERY_KEYS.uniqueShipVia);

      toast.success("Save Successful", { toastId: toastSettingsId });
    },
  });
};

// COD Default Values

export const useGetCDKCodDefaultValues = () =>
  useQuery({
    queryKey: QUERY_KEYS.codDefaultValues,
    queryFn: async () => {
      const response = await getCDKCodDefaultValues();

      return response.data;
    },
  });

export const useGetCDKUniqueCODValues = () =>
  useQuery({
    queryKey: QUERY_KEYS.uniqueCODValues,
    queryFn: async () => {
      const response = await getCDKUniqueCODValues();

      return response.data;
    },
  });

export const usePostNewCDKCODDefaultSetting = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: postNewCdkCodDefaultSetting,

    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.codDefaultValues);
      queryClient.invalidateQueries(QUERY_KEYS.uniqueCODValues);

      toast.success("Save Successful", { toastId: toastSettingsId });
    },
  });
};

export const useUpdateCDKCODDefaultSetting = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateCdkCodDefaultSetting,

    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.codDefaultValues);
      queryClient.invalidateQueries(QUERY_KEYS.uniqueCODValues);

      toast.success("Save Successful", { toastId: toastSettingsId });
    },
  });
};
